// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"125":"564eca90","234":"80c9442a","353":"7dd3d515"}[chunkId] + ".js";
};